import api from './api'

export const getParkByCustID = params => {
  return api.post(`/CloudParkAPI/Park/GetParkByCustID`, params)
}

export const getRootParkAndCust = params => {
  return api.post(`/CloudParkAPI/Park/GetRootParkAndCust`, params)
}

export const getParkByCurrUser = params => {
  return api.post(`/CloudParkAPI/Park/GetParkByCurrUser`, params)
}

export const getParkOtherSetByCurrUser = params => {
  return api.post(`/CloudParkAPI/Park/getParkOtherSetByCurrUser`, params)
}

export const getAllParkOtherSetParam = params => {
  return api.post(`/CloudParkAPI/Park/getAllParkOtherSetParam`, params)
}

export const saveParkOtherSet = params => {
  return api.post(`/CloudParkAPI/Park/saveParkOtherSet`, params)
}

export const exportParkSHRoadData = params => {
  return api.post(`/CloudParkAPI/Park/ExportParkSHRoadData`, params)
}

export const getParkPayParams = params => {
  return api.post(`/CloudParkAPI/Park/GetParkPayParams`, params)
}

export const getCustByGroup = params => {
  return api.post(`/CloudParkAPI/Park/GetCustByGroup`, params)
}

export const getPlatCardGroup = params => {
  return api.post(`/CloudParkAPI/Park/GetPlatCardGroup`, params)
}

export const getAllParkParamByParkId = params => {
  return api.post(`/CloudParkAPI/Park/GetAllParkParamByParkId`, params)
}

export const getChannelByQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetChannelByQuery`, params)
}
export const getParkingLockQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetParkingLockQuery`, params)
}
export const getParkingGeoQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetParkingGeoQuery`, params)
}
export const getShappRegisterList = params => {
  return api.post(`/CloudParkAPI/Park/GetShappRegisterList`, params)
}
export const getParkDevCamQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetParkDevCamQuery`, params)
}
export const getEhallCardTimeoutQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetEhallCardTimeoutQuery`, params)
}
export const parkGeoDataUpload = params => {
  return api.post(`/CloudParkAPI/Park/ParkGeoDataUpload`, params)
}
export const importParkGeoData = params => {
  return api.post(`/CloudParkAPI/Park/ImportParkGeoData`, params)
}
export const getFilterPlateCodeQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetFilterPlateCodeQuery`, params)
}
export const getChannelParamById = params => {
  return api.post(`/CloudParkAPI/Park/GetChannelParamById`, params)
}
export const getMapAndParkType = params => {
  return api.post(`/CloudParkAPI/Park/getMapAndParkType`, params)
}
export const getChannelSelectParam = params => {
  return api.post(`/CloudParkAPI/Park/GetChannelSelectParam`, params)
}
export const savePark = params => {
  return api.post(`/CloudParkAPI/Park/SavePark`, params)
}
export const deletePark = params => {
  return api.post(`/CloudParkAPI/Park/DeletePark`, params)
}
export const synParkById = params => {
  return api.post(`/CloudParkAPI/Park/SynParkById`, params)
}
export const saveChannel = params => {
  return api.post(`/CloudParkAPI/Park/SaveChannel`, params)
}
export const saveParkLock = params => {
  return api.post(`/CloudParkAPI/Park/SaveParkLock`, params)
}
export const saveParkLockNotifyConfig = params => {
  return api.post(`/CloudParkAPI/Park/SaveParkLockNotifyConfig`, params)
}
export const saveParkGeomagnetic = params => {
  return api.post(`/CloudParkAPI/Park/SaveParkGeomagnetic`, params)
}
export const saveShappRegister = params => {
  return api.post(`/CloudParkAPI/Park/SaveShappRegister`, params)
}
export const saveFilterPlateCode = params => {
  return api.post(`/CloudParkAPI/Park/SaveFilterPlateCode`, params)
}
export const deleteChannel = params => {
  return api.post(`/CloudParkAPI/Park/DeleteChannel`, params)
}
export const deleteParkLock = params => {
  return api.post(`/CloudParkAPI/Park/DeleteParkLock`, params)
}
export const deleteParkGeo = params => {
  return api.post(`/CloudParkAPI/Park/DeleteParkGeo`, params)
}
export const sendSMS = params => {
  return api.post(`/CloudParkAPI/Park/SendSMS`, params)
}
export const parkGeoDataTemplate = params => {
  return api.get(`/CloudParkAPI/Park/ParkGeoDataTemplate`, params)
}
export const deleteFilterPlateCode = params => {
  return api.post(`/CloudParkAPI/Park/DeleteFilterPlateCode`, params)
}
export const importFilterPlateCodeData = params => {
  return api.post(`/CloudParkAPI/Park/ImportFilterPlateCodeData`, params)
}
export const filterPlateCodeUpload = params => {
  return api.post(`/CloudParkAPI/Park/FilterPlateCodeUpload`, params)
}
export const filterPlateCodeDataTemplate = params => {
  return api.get(`/CloudParkAPI/Park/FilterPlateCodeDataTemplate`, params)
}
export const ascParkLock = params => {
  return api.post(`/CloudParkAPI/Park/AscParkLock`, params)
}
export const descParkLock = params => {
  return api.post(`/CloudParkAPI/Park/DescParkLock`, params)
}
export const descOrAecParkLock = params => {
  return api.post(`/CloudParkAPI/Park/DescOrAecParkLock`, params)
}
export const getParkLockStatus = params => {
  return api.post(`/CloudParkAPI/Park/GetParkLockStatus`, params)
}
export const synChnlById = params => {
  return api.post(`/CloudParkAPI/Park/SynChnlById`, params)
}
export const getParkList = params => {
  return api.post(`/CloudParkAPI/Park/GetParkList`, params)
}
export const getUsrList = params => {
  return api.post(`/CloudParkAPI/Park/GetUsrList`, params)
}
export const getCustomizedCardParkList = params => {
  return api.post(`/CloudParkAPI/Park/GetCustomizedCardParkList`, params)
}
export const getParkLockConfiguration = params => {
  return api.post(`/CloudParkAPI/Park/GetParkLockConfiguration`, params)
}
export const saveParkPay = params => {
  return api.post(`/CloudParkAPI/Park/SaveParkPay`, params)
}
export const getParkPayLink = params => {
  return api.post(`/CloudParkAPI/Park/GetParkPayLink`, params)
}
export const getParkSeatLink = params => {
  return api.post(`/CloudParkAPI/Park/GetParkSeatLink`, params)
}
export const deleteRoadSidePark = params => {
  return api.post(`/CloudParkAPI/Park/DeleteRoadSidePark`, params)
}
export const saveRoadSidePark = params => {
  return api.post(`/CloudParkAPI/Park/SaveRoadSidePark`, params)
}
export const getRoadSideParkParams = params => {
  return api.post(`/CloudParkAPI/Park/GetRoadSideParkParams`, params)
}
export const parkPlaceList = params => {
  return api.post(`/CloudParkAPI/Park/ParkPlaceList`, params)
}
export const parkPlaceEdit = params => {
  return api.post(`/CloudParkAPI/Park/ParkPlaceEdit`, params)
}
export const parkPlaceInfo = (id) => {
  return api.get(`/CloudParkAPI/Park/ParkPlaceInfo/${id}`)
}
export const parkPlaceDelete = (id) => {
  return api.get(`/CloudParkAPI/Park/ParkPlaceDelete/${id}`)
}
export const saveRoadSidePDA = params => {
  return api.post(`/CloudParkAPI/Park/SaveRoadSidePDA`, params)
}
export const getPdaByQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetPdaByQuery`, params)
}
export const deleteRoadSidePDA = params => {
  return api.post(`/CloudParkAPI/Park/DeleteRoadSidePDA`, params)
}
export const parkPlaceInit = params => {
  return api.post(`/CloudParkAPI/Park/ParkPlaceInit`, params)
}
export const editPDAPwd = params => {
  return api.post(`/CloudParkAPI/Park/EditPDAPwd`, params)
}
export const roadSideDevTypeList = () => {
  return api.get(`/CloudParkAPI/Park/RoadSideDevTypeList`)
}
export const getChannelList = (params) => {
  return api.post(`/CloudParkAPI/Park/GetChannelList`, params)
}
export const channelList = (params) => {
  return api.post(`/CloudParkAPI/Park/ChannelList`, params)
}
export const getParkSensitivePlateCode = (params) => {
  return api.post(`/CloudParkAPI/Park/getParkSensitivePlateCode`, params)
}
export const nbiotEdit = params => {
  return api.post(`/CloudParkAPI/Park/NBIOTEdit`, params)
}
export const nbiotList = params => {
  return api.post(`/CloudParkAPI/Park/NBIOTList`, params)
}
export const nbiotDelete = (id) => {
  return api.get(`/CloudParkAPI/Park/NBIOTDelete/${id}`)
}
export const nbiotViewList = params => {
  return api.post(`/CloudParkAPI/Park/NBIOTViewList`, params)
}
export const createQcodeImg = params => {
  return api.post(`/CloudParkAPI/Park/CreateQcodeImg`, params)
}
export const getLedByQuery = params => {
  return api.post(`/CloudParkAPI/Park/GetLedByQuery`, params)
}
export const deleteLED = params => {
  return api.post(`/CloudParkAPI/Park/DeleteLED`, params)
}
export const saveLED = params => {
  return api.post(`/CloudParkAPI/Park/SaveLED`, params)
}
export const getLedParkList = params => {
  return api.post(`/CloudParkAPI/Park/GetLedParkList`, params)
}
export const getPayUrl = () => {
  return api.get(`/CloudParkAPI/Park/GetPayUrl`)
}
export const getAdTempPageList = params => {
  return api.post(`/CloudParkAPI/Park/GetAdTempPageList`, params)
}
export const saveAdTemp = params => {
  return api.post(`/CloudParkAPI/Park/SaveAdTemp`, params)
}
export const getAdTempInfo = (id) => {
  return api.get(`/CloudParkAPI/Park/GetAdTempInfo/${id}`)
}
export const deleteAdtemp = (id) => {
  return api.get(`/CloudParkAPI/Park/DeleteAdtemp/${id}`)
}
export const getAdTempList = () => {
  return api.get(`/CloudParkAPI/Park/GetAdTempList`)
}
export const getAdTempBizPageList = params => {
  return api.post(`/CloudParkAPI/Park/GetAdTempBizPageList`, params)
}
export const saveAdTempBiz = params => {
  return api.post(`/CloudParkAPI/Park/SaveAdTempBiz`, params)
}
export const deleteAdTempBiz = (id) => {
  return api.get(`/CloudParkAPI/Park/DeleteAdTempBiz/${id}`)
}
export const setAdTempStatus = params => {
  return api.post(`/CloudParkAPI/Park/SetAdTempStatus`, params)
}
export const initBST = params => {
  return api.post(`/CloudParkAPI/Park/initBST`, params)
}
export const initBSTTwo = params => {
  return api.post(`/CloudParkAPI/Park/InitBSTTwo`, params)
}
export const getParkInfo = params => {
  return api.post(`/CloudParkAPI/Park/GetParkInfo`, params)
}



// WEBPACK FOOTER //
// ./src/api/park.js